import clsx from "classnames";
import { Col, Container, Row } from "react-bootstrap";
import Logo from "@/assets/Logo.svg";
import SourceFlow from "@/assets/SourceFlow.svg";
import classes from "./styles.module.scss";
import { QuickLinks } from "./components/QuickLinks";
import { GetInTouch } from "./components/GetInTouch";
import { Companies } from "./components/Companies";
import { Frameworks } from "../Frameworks";
import { ConnectWithUs } from "@/components/ConnectWithUs";

export default function AppFooter({ className }) {
  return (
    <footer className={clsx(className, classes.footer)}>
      <div className="bg-grey-dark text-white py-5 py-md-6">
        <Container fluid="lg">
          <Logo width="203" height="65" style={{ fill: "white" }} />
          <Row className="mt-5">
            <Col md={5}>
              <GetInTouch className="mb-5 mb-md-0 pb-2 pb-md-0" />
            </Col>
            <Col md={3}>
              <QuickLinks className="mb-5 mb-md-0 pb-2 pb-md-0" />
            </Col>
            <Col md={4} className="d-flex flex-column justify-content-between">
              <Companies className="me-4 me-md-0 mb-5" />
              <Frameworks className={clsx(classes.footer__frameworks, "me-6 md-md-0")} />
            </Col>
          </Row>
        </Container>
      </div>
      <div className="bg-grey-darker text-white py-4">
        <Container fluid="lg" className="d-flex flex-column flex-md-row justify-content-between">
          <ConnectWithUs />
          <div className="d-flex flex-column flex-md-row gap-1">
            <span>© 2023 IT Works Health.</span>
            <span>
              Website by <SourceFlow />
            </span>
          </div>
        </Container>
      </div>
    </footer>
  );
}
